import { GeoJsonProperties } from 'geojson'
import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

export const PopUp = ({
  data,
  pos,
  anchor,
}: {
  data: GeoJsonProperties
  pos: { x: number; y: number }
  anchor: string
}) => {
  const { width, height } = useWindowSize()

  const {
    Leichtverletzte,
    Schwerverletzte,
    Getötete,
    Alter_Fahrer,
    Führerausweisalter_Fahrer,
    Unfalltyp,
    Jahr,
  } = data

  if (
    !data ||
    pos.x < -width * 0.2 ||
    pos.x > width * 1.2 ||
    pos.y < -height * 0.2 ||
    pos.y > height * 1.2
  )
    return null
  const type = Getötete > 0 ? 'death' : data.filter_schwer ? 'heavy' : 'light'
  return (
    <>
      <Marker
        top={anchor.includes('top')}
        left={anchor.includes('left')}
        pos={pos}
        type={type}
      />
      <_PopUp
        type={type}
        top={anchor.includes('top')}
        left={anchor.includes('left')}
        pos={pos}
        className={anchor}
      >
        {Jahr && <Date>{Jahr}</Date>}
        {Leichtverletzte > 0 && (
          <>
            <Label>Leichtverletzte</Label>
            <DriverAge>{Leichtverletzte}</DriverAge>
          </>
        )}
        {Schwerverletzte > 0 && (
          <>
            <Label>Schwerverletzte</Label>
            <DriverAge>{Schwerverletzte}</DriverAge>
          </>
        )}
        {Getötete > 0 && (
          <>
            <Label>Getötete</Label>
            <DriverAge>{Getötete}</DriverAge>
          </>
        )}
        {Alter_Fahrer > 0 && (
          <>
            <Label>Alter des Fahrers</Label>
            <DriverAge>{Alter_Fahrer}</DriverAge>
          </>
        )}
        {Führerausweisalter_Fahrer > 0 &&
          Führerausweisalter_Fahrer !== 'unbekannt' && (
            <>
              <Label>Im Besitz des Führerscheins seit</Label>
              <LicenceAge>
                {+Führerausweisalter_Fahrer === 0
                  ? 'weniger als 1 Jahr'
                  : +Führerausweisalter_Fahrer === 1
                  ? '1 Jahr'
                  : Führerausweisalter_Fahrer + ' Jahren'}
              </LicenceAge>
            </>
          )}
        {Unfalltyp && (
          <>
            <Label>Unfallursache</Label>
            <Causes>{Unfalltyp}</Causes>
          </>
        )}
      </_PopUp>
    </>
  )
}
const border = '3px solid var(--text-color)'
const typeColors = { light: '#FFE462', heavy: '#E16D00', death: '#D3343F' }
const typeTextColors = { light: '#202346', heavy: '#fff', death: '#fff' }

const Marker = styled.div<{
  type: 'light' | 'heavy' | 'death'
  top: boolean
  left: boolean
  pos: { x: number; y: number }
}>`
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 10px;
  background-color: var(--text-color);

  position: absolute;
  z-index: 2;
  left: ${({ pos }) => pos.x + 'px'};
  top: ${({ pos }) => pos.y + 'px'};
  transform: translate(-50%, -50%);
`
const _PopUp = styled.div<{
  type: 'light' | 'heavy' | 'death'
  top: boolean
  left: boolean
  pos: { x: number; y: number }
}>`
  font-family: var(--font-sans-serif);
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.2px;
  font-weight: 400;
  padding: 10px;
  background-color: ${({ type }) => typeColors[type]};
  color: ${({ type }) => typeTextColors[type]};
  border-bottom: ${({ top }) => (top ? undefined : border)};
  border-top: ${({ top }) => (top ? border : undefined)};
  border-right: ${({ left }) => (left ? undefined : border)};
  border-left: ${({ left }) => (left ? border : undefined)};
  width: 300px;
  transform: translate(
    ${({ left }) => (left ? '0' : '-100%')},
    ${({ top }) => (top ? '0' : '-100%')}
  );

  position: absolute;
  z-index: 2;
  left: ${({ pos }) => pos.x + 'px'};
  top: ${({ pos }) => pos.y + 'px'};
  @media only screen and (max-width: 711px) {
    width: 48vw;
  }
`
const Causes = styled.div`
  font-weight: 700;
  margin-bottom: 0.5em;
`
const Date = styled.div`
  margin-bottom: 0.5em;
`
const DriverAge = styled.div`
  font-weight: 700;
`
const LicenceAge = styled.div`
  font-weight: 700;
  margin-bottom: 0.5em;
`
const Label = styled.div`
  font-size: 12.5px;
  /* color: var(--brandblue-main); */
  margin-top: 0.5em;
`
